//region :: Imports ::
import {ReactElement} from 'react';
import {ProgressSpinner} from 'primereact/progressspinner';
import MComponent from '../Component';
import {isNullOrUndefined} from '../../Utils';
import {evalulateBool, MBoolean} from './Control';

//endregion

/** */
type Props = {
    text?: string;
    isBusy?: MBoolean;
}

/** */
class MDropDownSelection extends MComponent<Props> {

    /** */
    public render(): ReactElement {

        return (
            <div className="flex align-items-center">
                {evalulateBool(this.props.isBusy) && <ProgressSpinner className="m-0 mr-2" strokeWidth="8" style={{'height': '16px', 'width': '16px'}}/>}
                {isNullOrUndefined(this.props.text) ? '[[Empty]]' : this.props.text}
            </div>
        );

    }

}

export default MDropDownSelection;
